import MotifAATState from './types';
import { MutationTree, Module, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { MotifAAT } from './types';

const namespaced: boolean = true;

export const state: MotifAATState = {
	motif: null
};

export const mutations: MutationTree<MotifAATState> = {
	mutateMotif(state: MotifAATState, motif: MotifAAT): void {
		state.motif = motif;
	},
	mutateComplementInfo(state: MotifAATState, complementInfo: string): void {
		if (state.motif != null) {
			state.motif.complementInfo = complementInfo;
		}
	},
	mutateCategorie(state: MotifAATState, categorie: string): void {
		if (state.motif != null) {
			state.motif.categorie = categorie;
		}
	}
};

export const actions: ActionTree<MotifAATState, RootState> = {
	updateMotif(state, motif: MotifAAT): void {
		state.commit('mutateMotif', motif);
	},
	updateComplementInfo(state, complementInfo: string): void {
		state.commit('mutateComplementInfo', complementInfo);
	},
	updateCategorie(state, categorie: string): void {
		state.commit('mutateCategorie', categorie);
	}
};

export const getters: GetterTree<MotifAATState, RootState> = {
	getMotif(state) {
		return state.motif;
	}
};

export const motifAAT: Module<MotifAATState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
